import React from 'react';
import "../css/loading.css";
const Loading = () => {
    return (
        <div className={"loading"}>
            <p className={"spinner"}> </p>
        </div>
    );
};

export default Loading;